import currenciesService from "./currenciesService";
import events from "./events";
import currencyApiClient from "./clients/CurrencyApiClient";
const DefaultCurrency = "NOK";
export function Currencies() {
    return {
        exchangeRates: {},
        currencies: [],
        selectedCurrency: DefaultCurrency,
        init() {
            currencyApiClient.getExchangeRates().then((data) => {
                // Remove placeholder NOK item
                const el = document.getElementById("currencyPlaceholder");
                el.remove();
                this.exchangeRates = data;
                for (const currency in data) {
                    this.currencies.push(currency);
                }
                const localStorageCurrency = currenciesService.getRate();
                if (!localStorageCurrency)
                    return;
                this.selectedCurrency = localStorageCurrency.currency;
                const newLocalStorageCurrency = {
                    currency: localStorageCurrency.currency,
                    rate: data[localStorageCurrency.currency],
                };
                currenciesService.setRate(newLocalStorageCurrency);
            });
        },
        onChange(e) {
            if (!this.exchangeRates[e.target.value])
                return;
            const data = {
                currency: e.target.value,
                rate: this.exchangeRates[e.target.value],
            };
            currenciesService.setRate(data);
            events.onCurrencyChanged.trigger(data);
        },
    };
}
